import styled from 'styled-components';
import { Link } from 'react-router-dom';
import loginIllustration from 'assets/svg/login-illustration.svg';
import { Button as ButtonComponent, Form as FormComponent } from 'components';
import { withTheme } from '@material-ui/core/styles';
import { TextField as TextFieldComponent } from 'components/TextField/TextField';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: row;
  background: white;
`;

export const Illustration = styled.div`
  background-image: url(${loginIllustration});
  background-repeat: no-repeat;
  background-size: contain;
  background-attachment: fixed;
  width: 60%;
  height: 100%;

  @media screen and (max-width: 950px) {
    display: none;
  }
`;

export const Form = styled(FormComponent)`
  display: flex;
  justify-content: center;
  padding: 30px;
  width: 40%;
  max-width: 480px;

  @media (max-width: 950px) {
    margin: auto;
    width: 100%;
  }
`;

export const Title = styled.h1`
  height: 37px;
  font-size: 30px;
  font-weight: 600;
  line-height: 1.23;
  color: #323232;
  margin: 0 0 30px 0;
`;

export const Description = styled.p`
  height: 44px;
  font-size: 18px;
  font-weight: 300;
  line-height: 1.22;
  color: #323232;
  margin: 0 0 50px 0;
`;

export const ForgotPassword = styled(Link)`
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  color: #000;
  text-align: center;
  margin-top: 20px;
  text-decoration: none;
`;

export const TextField = withTheme(styled(TextFieldComponent)`
  && {
    margin-bottom: ${(props): number => props.theme.spacing(2.5)}px;
    margin-top: ${(props): number => props.theme.spacing(1)}px;
  }
`);

export const Button = withTheme(styled(ButtonComponent)`
  && {
    margin-top: ${(props): number => props.theme.spacing(2)}px;
  }
`);
